import request from '@/utils/request'

// 查询列表 通过编号
export function getGoodsListByQuery(query) {
  return request({
    url: '/api/goods/getGoodsListByQuery',
    method: 'GET',
    params: query ,
  })
}// 查询历史查询记录
export function getTextListReq(query) {
  return request({
    url: '/api/home/getTextList',
    method: 'GET',
    params: query ,
  })
}


// 改装卡钳分类
export function getCategoryBrakeFluidReq(query) {
  return request({
    url: '/api/category/getCategoryBrakeFluid',
    method: 'GET',
    params: query ,
  })
}
// 查询列表 通过刹车油
export function getGoodsListByBrakeFluidAndOther(query) {
  return request({
    url: '/api/goods/getGoodsListByBrakeFluidAndOther',
    method: 'GET',
    params: query ,
  })
}

// 查询历史查询记录
export function getAutoInfoVinListReq() {
  return request({
    url: '/api/home/getAutoInfoVinList',
    method: 'GET',
  })
}

// 加入购物车请求
export function addCartItemReq(query) {
  return request({
    url: '/api/cartItem/addCartItem',
    method: 'GET',
    params: query ,

  })
}

// 改装卡钳分类
export function getCategoryCaliperReq(query) {
  return request({
    url: '/api/category/getCategoryCaliper',
    method: 'GET',
    params: query ,
  })
}
//改装卡钳分类列表
export function getGoodsListByCaliperReq(query) {
  return request({
    url: '/api/goods/getGoodsListByCaliper',
    method: 'GET',
    params: query ,
  })
}

//获取全部品牌列表
export function getAllAutoBrandReq(query) {
  return request({
    url: '/api/home/getAllAutoBrand',
    method: 'GET',
    params: query ,
  })
}

//根据品牌查询明细
export function getAutoSelectByBrandReq(query) {
  return request({
    url: '/api/home/getAutoSelectByBrand',
    method: 'GET',
    params: query ,
  })
}
//根据
export function getAutoDetailReq(query) {
  return request({
    url: '/api/home/getAutoDetail',
    method: 'GET',
    params: query ,
  })
}
//获取刹车类型
export function getChooseAutoParamByAutoReq(query) {
  return request({
    url: '/api/home/getChooseAutoParamByAuto',
    method: 'GET',
    params: query ,
  })
}

//获取品项
export function getItemsReq(query) {
  return request({
    url: '/api/home/getItems',
    method: 'GET',
    params: query ,
  })
}

//从车型页面获取分类信息
export function getCategoryListByModelReq(query) {
  return request({
    url: '/api/category/getCategoryListByModel',
    method: 'GET',
    params: query ,
  })
}

//从车型页面获取商品信息
export function getGoodsListByModelReq(query) {
  return request({
    url: '/api/goods/getGoodsListByModel',
    method: 'GET',
    params: query ,
  })
}

//搜索查询
export function getAutoFuzzyQueryReq(query) {
  return request({
    url: '/api/home/getAutoFuzzyQuery',
    method: 'GET',
    params: query,
  })
}


  //搜索查询
export function getStockDetail(query) {
    return request({
      url: '/api/goods/stockDetail',
      method: 'GET',
      params: query ,
  })
}

